import React, { useEffect } from 'react';
import { OTPVerificationForm } from '../../../shared/otpVerificationForm/OTPVerificationForm';
import {
    Contact,
    useResendPhoneResetPasswordMutation,
    useResetPasswordVerifyPhoneOtpMutation
} from '../../../slices/auth-api.slice';
import { useHistory } from 'react-router-dom';
import { ERROR_PATH, RESET_PASSWORD_CHANGE_PASSWORD_PATH } from '../../../react-router-paths';
import { UNAUTH_FLOW } from '../../../shared/error-page/error-page';

interface VerifyPhoneStepProps {
    contacts: Array<Contact>;
}

export function VerifyPhoneStep({ contacts }: VerifyPhoneStepProps) {
    const history = useHistory();

    const [resetPasswordVerifyPhoneOtp, resetPasswordVerifyPhoneMutation] = useResetPasswordVerifyPhoneOtpMutation();
    const [resendPhoneResetPassword, resendPhoneResetPasswordMutation] = useResendPhoneResetPasswordMutation();

    const phoneContact = contacts.find(contact => contact.contactType === 'phone');

    const contactId = phoneContact?.contactId;

    useEffect(() => {
        if (resetPasswordVerifyPhoneMutation.isSuccess) {
            history.replace(RESET_PASSWORD_CHANGE_PASSWORD_PATH);
        }
        if (
            (resetPasswordVerifyPhoneMutation.isError &&
                // @ts-ignore
                resetPasswordVerifyPhoneMutation.error.data.error ===
                    'Too many failed attempts. Try again in an hour or check your email for further instructions to sign in.') ||
            resendPhoneResetPasswordMutation.isError
        ) {
            history.replace({
                pathname: ERROR_PATH,
                state: {
                    context: UNAUTH_FLOW
                }
            });
        }
    }, [history, resetPasswordVerifyPhoneMutation, resendPhoneResetPasswordMutation]);

    function onResend() {
        resendPhoneResetPassword({ contactId });
    }

    function onSubmit({ passcode }) {
        resetPasswordVerifyPhoneOtp({ passcode, contactId });
    }

    return (
        <OTPVerificationForm
            errorPath={ERROR_PATH}
            onResend={onResend}
            onSubmit={onSubmit}
            disabled={resetPasswordVerifyPhoneMutation.isLoading || resendPhoneResetPasswordMutation.isLoading}
            otpContact={phoneContact}
            mutation={resetPasswordVerifyPhoneMutation}
        />
    );
}
